export namespace PDFxEvents {
  export const PDFX_TEXT_ENTRY_TEXT_CHANGED: string = "pdfx:textentry:text-changed";

}

